// Small client-side cache of the Irish bank holidays served from
// /api/bank-holidays. Fetched once per page load and stored in-memory.
// Exposed as `isBankHoliday(date)` / `bankHolidayName(date)`.

import { api } from "@/api";

let cache = null; // { "YYYY-MM-DD": "St Patrick's Day", ... }
let inflight = null;

export async function loadBankHolidays() {
    if (cache) return cache;
    if (!inflight) {
        inflight = api.get("/bank-holidays")
            .then(r => {
                const map = {};
                for (const h of r.data.holidays || []) map[h.date] = h.name;
                cache = map;
                return map;
            })
            .catch(() => {
                cache = {};
                return cache;
            })
            .finally(() => { inflight = null; });
    }
    return inflight;
}

// Synchronous lookup — safe to call after loadBankHolidays() resolved once.
export function isBankHoliday(iso) {
    return !!(cache && cache[iso]);
}

export function bankHolidayName(iso) {
    return (cache && cache[iso]) || null;
}

// Handy for JSX components: hook that returns the map + a loading state.
import { useEffect, useState } from "react";
export function useBankHolidays() {
    const [map, setMap] = useState(cache);
    useEffect(() => {
        if (cache) { setMap(cache); return; }
        loadBankHolidays().then(setMap);
    }, []);
    return map || {};
}
